"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.azureAuthentication = void 0;
const RadioButtons_1 = require("../RadioButtons");
const Note_1 = require("../Note");
const Account_1 = require("../Account");
const Link_1 = require("../Link");
function azureAuthentication({ input }) {
    const content = [
        (0, RadioButtons_1.radioButtons)({
            input: input.credentials,
            label: "Credentials",
            helpText: "Select the Azure authentication method.",
            options: [
                {
                    label: "Use a Service Principal Account",
                    newValue: {
                        type: "account",
                    },
                },
                {
                    label: "Use an OpenID Connect Account",
                    newValue: {
                        type: "oidcAccount",
                    },
                },
            ],
            note: (0, Note_1.note) `Azure Service Principals support both Credential and Open Id Connect based authentication. For more information on Oidc accounts in Octopus see ${(0, Link_1.link)({
                title: "OpenID Connect Accounts",
                href: "OpenIdConnectClientConfiguration",
            })}.`,
        }),
    ];
    if (input.credentials.type === "account") {
        content.push((0, Account_1.account)({
            input: input.credentials.account,
            label: "Azure Account",
            helpText: "The account to authenticate with.",
        }));
    }
    if (input.credentials.type === "oidcAccount") {
        content.push((0, Account_1.account)({
            input: input.credentials.account,
            label: "Azure OIDC Account",
            helpText: "The OpenID Connect account to authenticate with.",
        }));
    }
    return content;
}
exports.azureAuthentication = azureAuthentication;
//# sourceMappingURL=AzureAuthentication.js.map